import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Box, CircularProgress } from '@mui/material';

/**
 * Renderiza un código QR a partir de un texto/URL usando la librería qrcode.
 * Genera un data URL PNG que se muestra en un <img>, apto para imprimir.
 */
export default function QrImage({ value, size = 240, alt = 'Código QR' }) {
    const [dataUrl, setDataUrl] = useState('');

    useEffect(() => {
        let activo = true;
        if (!value) {
            setDataUrl('');
            return;
        }
        QRCode.toDataURL(value, {
            errorCorrectionLevel: 'M',
            margin: 1,
            width: size,
        }).then((url) => {
            if (activo) setDataUrl(url);
        }).catch(() => {
            if (activo) setDataUrl('');
        });
        return () => { activo = false; };
    }, [value, size]);

    if (!dataUrl) {
        return (
            <Box sx={{ width: size, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress size={28} />
            </Box>
        );
    }

    return <img src={dataUrl} width={size} height={size} alt={alt} style={{ display: 'block' }} />;
}
